import React from "react";
import 'bootstrap/dist/css/bootstrap.min.css';


export function Header() {
    return(
        <h1 className="text-center">To Do List</h1>
    )
}